<template>
    <section class="bg--white m-0 position-relative no-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="main col-12 col-md-10 offset-md-1">
                    <h2 class="heading-spacing--large mb-4">
                        Registreren bij Verwonder om de Hoek
                    </h2>

                    <slot name="introductionText"></slot>
                    <validation-observer ref="form">
                        <p v-if="error" class="input-error">
                            {{ errorMessage }}
                        </p>

                        <form action="" class="row">
                            <div class="col-12 col-lg-10 mb-4">
                                <h2 class="pb-2 heading-spacing--medium">
                                    <label
                                        for="memberType"
                                        class="control-label"
                                        >Ik schrijf me in als</label
                                    >
                                </h2>
                                <v-selector
                                    id="memberType"
                                    v-model="memberType"
                                    type="text"
                                    placeholder="Maak een keuze"
                                    class="v-select--fill col-12 col-sm-6 col-md-5 col-lg-4 pl-0"
                                    :options="[
                                        {
                                            label: 'Ouder/Voogd',
                                            type: 'parent'
                                        },
                                        { label: 'BSO', type: 'bso' }
                                    ]"
                                >
                                </v-selector>
                            </div>
                            <div
                                v-if="memberType.type == 'parent'"
                                class="form-section"
                            >
                                <h2 class="heading-spacing--medium pb-2">
                                    Gegevens ouder/voogd
                                </h2>
                                <div class="row">
                                    <text-input
                                        v-model="
                                            parentInformation.contactPersonFirstname
                                        "
                                        class="col-12 col-md-4"
                                        name="Voornaam"
                                        rules="required"
                                    />
                                    <text-input
                                        v-model="
                                            parentInformation.contactPersonInsertion
                                        "
                                        class="col-12 col-md-2"
                                        name="Tussenvoegsel"
                                    />
                                    <text-input
                                        v-model="
                                            parentInformation.contactPersonLastname
                                        "
                                        class="col-12 col-md-4"
                                        name="Achternaam"
                                        rules="required"
                                    />
                                    <text-input
                                        v-model="
                                            parentInformation.contactPersonPhone
                                        "
                                        class="col-12 col-md-5"
                                        name="Telefoonnummer"
                                        rules="required"
                                    />
                                    <text-input
                                        v-model="emailaddress"
                                        class="col-12 col-md-5"
                                        name="E-mailadres"
                                        rules="required|email"
                                    />
                                </div>
                            </div>

                            <div
                                v-if="memberType.type == 'bso'"
                                class="form-section"
                            >
                                <h2 class="heading-spacing--medium pb-2">
                                    Gegevens BSO
                                </h2>
                                <div class="row">
                                    <text-input
                                        v-model="bsoInformation.name"
                                        class="col-12 col-md-7"
                                        name="Naam organisatie"
                                        rules="required"
                                    />
                                    <text-input
                                        v-model="bsoInformation.lrk"
                                        class="col-12 col-md-5"
                                        name="LRK-nummer"
                                        rules="required"
                                    />
                                </div>
                            </div>

                            <div
                                v-if="memberType.type == 'bso'"
                                class="form-section"
                            >
                                <h2 class="heading-spacing--medium pb-2">
                                    Adresgegevens organisatie
                                </h2>
                                <div class="row">
                                    <text-input
                                        v-model="bsoInformation.street"
                                        class="col-12 col-md-6"
                                        name="Straatnaam"
                                        rules="required"
                                    />
                                    <text-input
                                        v-model="bsoInformation.zipcode"
                                        class="col-12 col-md-6"
                                        name="Postcode"
                                        rules="required"
                                    />
                                    <text-input
                                        v-model="bsoInformation.housenumber"
                                        class="col-12 col-md-3"
                                        name="Huisnummer"
                                        rules="required"
                                    />
                                    <text-input
                                        v-model="
                                            bsoInformation.housenumberAddition
                                        "
                                        class="col-12 col-md-3"
                                        name="Toevoeging"
                                    />
                                    <text-input
                                        v-model="bsoInformation.city"
                                        class="col-12 col-md-6"
                                        name="Plaats"
                                        rules="required"
                                    />
                                </div>
                            </div>

                            <div
                                v-if="memberType.type == 'bso'"
                                class="form-section"
                            >
                                <h2 class="heading-spacing--medium pb-2">
                                    Account en contactpersoon
                                </h2>
                                <div class="row">
                                    <text-input
                                        v-model="
                                            bsoInformation.contactPersonFirstname
                                        "
                                        class="col-12 col-md-5"
                                        name="Voornaam"
                                        rules="required"
                                    />
                                    <text-input
                                        v-model="
                                            bsoInformation.contactPersonInsertion
                                        "
                                        class="col-12 col-md-2"
                                        name="Tussenvoegsel"
                                    />
                                    <text-input
                                        v-model="
                                            bsoInformation.contactPersonLastname
                                        "
                                        class="col-12 col-md-5"
                                        name="Achternaam"
                                        rules="required"
                                    />
                                    <text-input
                                        v-model="
                                            bsoInformation.contactPersonPhone
                                        "
                                        class="col-12 col-md-6"
                                        name="Telefoonnummer"
                                        rules="required"
                                    />
                                    <text-input
                                        v-model="emailaddress"
                                        class="col-12 col-md-6"
                                        name="E-mailadres (gebruikersnaam)"
                                        rules="required|email"
                                    />
                                </div>
                            </div>
                            <div class="form-section">
                                <h2 class="heading-spacing--medium pb-2">
                                    Nieuwsbrieven/overig
                                </h2>
                                <div class="row">
                                    <checkbox-input
                                        v-model="newsletterVerwonder"
                                        class="col-12 mb-2"
                                        name="Nieuwsbrief 'om de hoek'"
                                    >
                                        <slot>Nieuwsbrief 'om de hoek' </slot>
                                    </checkbox-input>
                                    <checkbox-input
                                        v-if="privacyLink"
                                        v-model="privacyAccepted"
                                        class="col-12 mb-2"
                                        name="U dient akkoord te gaan met de algemene voorwaarden"
                                        rules="required"
                                    >
                                        <slot>
                                            Ik ga akkoord met de
                                            <a
                                                :href="privacyLink"
                                                target="_blank"
                                                class="ml-1 color--blue-7"
                                            >
                                                <span>
                                                    algemene voorwaarden
                                                </span>
                                            </a>
                                        </slot>
                                    </checkbox-input>
                                </div>
                            </div>
                            <div v-if="!processing" class="col-12 col-lg-10">
                                <button
                                    v-if="!registrationSend"
                                    class="col-4 btn btn--blue-7"
                                    @click="register"
                                >
                                    <span>
                                        Registreren
                                        <i class="fas fa-check"></i>
                                    </span>
                                </button>
                            </div>
                            <div
                                v-else
                                class="col-12 d-flex fixed-top justify-content-center align-items-center message--top"
                            >
                                <span>Een moment geduld...</span>
                            </div>

                            <div
                                v-if="statusMessage"
                                class="col-12 d-flex fixed-top justify-content-center align-items-center message--top"
                            >
                                <p>{{ statusMessage }}</p>
                            </div>
                        </form>
                    </validation-observer>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { initVeeValidate } from '@/plugins/vee-validate';
import checkboxInput from '@/components/form/checkbox-input';
import textInput from '@/components/form/text-input';
import axios from 'axios';

initVeeValidate();

export default {
    components: {
        ValidationObserver,
        textInput,
        checkboxInput
    },
    data() {
        return {
            emailaddress: '',
            memberType: '',
            response: '',
            error: false,
            errors: [],
            errorMessage:
                'Controleer jouw invoer, mogelijk zijn er verplichte velden niet ingevuld of zijn er velden niet correct ingevuld.',
            statusMessage: '',
            processing: false,
            newsletterVerwonder: false,
            privacyAccepted: false,
            privacyLink: {},
            registrationSend: false,
            parentInformation: {
                contactPersonFirstname: '',
                contactPersonInsertion: '',
                contactPersonLastname: '',
                contactPersonPhone: ''
            },
            memberTypeItems: ['Bso', 'Ouder'],
            bsoInformation: {
                name: '',
                lrk: '',
                street: '',
                housenumber: '',
                housenumberAddition: '',
                zipcode: '',
                city: '',
                contactPersonFirstname: '',
                contactPersonInsertion: '',
                contactPersonLastname: '',
                contactPersonPhone: ''
            }
        };
    },
    mounted() {
        this.getPrivacyLink();
    },
    methods: {
        register(e) {
            if (this.processing) {
                return;
            }
            e.preventDefault();
            this.statusMessage = '';
            this.processing = true;
            this.registrationSend = false;

            if (this.memberType == '') {
                this.error = true;
                window.scrollTo(0, 0);

                return;
            }

            this.$refs.form.validate().then(success => {
                if (success) {
                    axios
                        .post('/clientdashboard/account/register', {
                            newsletterVerwonder: this.newsletterVerwonder,
                            emailaddress: this.emailaddress,
                            memberType: this.memberType.type,
                            parent: this.parentInformation,
                            bso: this.bsoInformation
                        })
                        .then(response => {
                            this.response = response;
                            this.error = false;
                            if (response.data.errorMsg) {
                                this.statusMessage = response.data.errorMsg;
                            } else {
                                this.statusMessage = response.data.successMsg;
                                this.registrationSend = true;
                            }

                            return;
                        })
                        .catch(e => {
                            this.errors.push(e);
                            this.error = true;
                        })
                        .finally(() => {
                            this.processing = false;
                        });
                } else {
                    this.processing = false;
                    window.scrollTo(0, 0);
                    this.error = true;
                }
            });
        },
        getPrivacyLink() {
            axios.get('/api/registration/privacylink').then(response => {
                this.privacyLink = response.data;
            });
        }
    }
};
</script>
<style></style>
